import * as api from '../api'
import { Dispatch } from '@reduxjs/toolkit';
import { endLoading, setDeleteUser, setSingleUser, setUpdateUser, setUsers, setUsersSearch, startLoading } from '../reducers/usersSlice';

export const actionFetchUsers = ({page}: api.ApiParams) => async(dispatch: Dispatch) => {
    try{
        dispatch({ type: startLoading.type })
        const { data } = await api.fetchUsers({page})
        dispatch({
            type: setUsers.type,
            payload: data
        })
        dispatch({ type: endLoading.type })
        return data
    }catch(error: any){
        dispatch({ type: endLoading.type });
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}

export const actionFetchUsersBySearch = ({searchQuery, page}: api.ApiParams) => async(dispatch: Dispatch) => {
    try{
        dispatch({ type: startLoading.type })
        const { data } = await api.fetchUsersBySearch({searchQuery, page})
        dispatch({
            type: setUsersSearch.type,
            payload: data
        })
        dispatch({ type: endLoading.type })
        return data
    }catch(error: any){
        dispatch({ type: endLoading.type });
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}

export const actionCreateUser = ({postData}: api.ApiParams) => async(dispatch: Dispatch) => {
    try{
        dispatch({ type: startLoading.type })
        const {data} = await api.createUser({postData});
        dispatch({
            type: setUsers.type,
            payload: data
        })
        dispatch({ type: endLoading.type })
        return data
    }catch(error: any){
        dispatch({ type: endLoading.type });
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}

export const actionFetchUser = ({id}: api.ApiParams) => async(dispatch: Dispatch) => {
    try{
        dispatch({ type: startLoading.type })
        const { data } = await api.fetchUser({id})
        dispatch({
            type: setSingleUser.type,
            payload: data
        })
        dispatch({ type: endLoading.type })
        return data
    }catch(error: any){
        dispatch({ type: endLoading.type });
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}

export const actionUpdateUser = ({id, updatedUser}: api.ApiParams) => async(dispatch: Dispatch) => {
    try{
        dispatch({ type: startLoading.type })
        const { data } = await api.updateUser({id, updatedUser})
        dispatch({
            type: setUpdateUser.type,
            payload: data
        })
        dispatch({ type: endLoading.type })
        return data
    }catch(error: any){
        dispatch({ type: endLoading.type });
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}

export const actionResendVerification = ({emailAddress}: api.ApiParams) => async() => {
    try{
        const response = await api.resendVerification({emailAddress})
        console.log("resend verification:", response)
        return response
    }catch(error: any){
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}

export const actionVerifyUserRegEmail = ({id, emailToken}: api.ApiParams) => async() => {
    try{
        const response = await api.verifyUserRegEmail({id, emailToken})
        return response;
    }catch(error: any){
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}

export const actionVerifyEmailPassword = ({emailAddress}: api.ApiParams) => async() => {
    try{
        const response = await api.verifyEmailPassword({emailAddress})
        return response
    }catch(error: any){
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}

export const actionUpdatePassword = ({id, updatedPassword}: api.ApiParams) => async() => {
    try{
        const response = await api.passwordReset({id, updatedPassword})
        return response;
    }catch(error: any){
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}

export const actionDeleteUser = ({id}: api.ApiParams) => async (dispatch: Dispatch) => {
    try{
        dispatch({ type: startLoading.type })
        const data = await api.deleteUser({id})
        dispatch({
            type: setDeleteUser.type,
            payload: id
        })
        dispatch({ type: endLoading.type })
        return data
    }catch(error: any){
        dispatch({ type: endLoading.type });
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}